import { OUTPUT_PRESETS, OutputPresetId } from '@/content/instagram'
import { documentOutputRatio } from '@/core/document'
import { EditAction } from '@/core/history'
import { useEditSession } from '@/core/store/editSession'
import { TEST_IDS } from '@/lib/testIds'
import { ChoiceGroup, ChoiceTile } from '@/ui/ChoiceTile'
import { InfoTip } from '@/ui/InfoTip'
import { ShapeIllustration } from '@/ui/illustrations/PanelIllustrations'

const PRESET_LABELS: Readonly<Record<OutputPresetId, string>> = {
  [OutputPresetId.Original]: 'Original',
  [OutputPresetId.Square]: 'Square',
  [OutputPresetId.Portrait]: 'Portrait',
  [OutputPresetId.Landscape]: 'Landscape',
  [OutputPresetId.Story]: 'Story',
}

export function PresetPicker() {
  const document = useEditSession((state) => state.document)
  const sources = useEditSession((state) => state.sources)
  const setOutputPreset = useEditSession((state) => state.setOutputPreset)
  const commitHistory = useEditSession((state) => state.commitHistory)
  if (!document) throw new Error('Preset picker requires a loaded document')
  const originalRatio = documentOutputRatio(document, sources)

  return (
    <ChoiceGroup mode="single" label="Output shape" className="grid-cols-2 sm:grid-cols-3">
      {OUTPUT_PRESETS.map((preset) => (
        <div key={preset.id} className="relative min-w-0">
          <ChoiceTile
            ariaLabel={PRESET_LABELS[preset.id]}
            label={PRESET_LABELS[preset.id]}
            illustration={<ShapeIllustration ratio={preset.ratio ?? originalRatio} />}
            selected={document.output.presetId === preset.id}
            disabled={document.output.split !== null}
            data-testid={TEST_IDS.preset(preset.id)}
            className="w-full"
            onClick={() => {
              setOutputPreset(preset.id)
              commitHistory(EditAction.ChangeOutputPreset)
            }}
          />
          <InfoTip topic={preset.helpTopic} testId={TEST_IDS.presetInfo(preset.id)} className="absolute right-0.5 top-0.5 z-10" />
        </div>
      ))}
    </ChoiceGroup>
  )
}
